"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chartTokens = void 0;
var _tokens = _interopRequireDefault(require("../../../../shared/tokens/tokens"));
var chartTokens = exports.chartTokens = {
  chart: {
    color: _tokens.default.sky.sys.color.graph
  }
};